module.exports = __webpack_public_path__ + "static/media/check_mark_circle_green.774a4b9b.svg";